<!-- <mat-checkbox [attr.name]="field.name" [formControl]="field.control" *ngIf="showField$ | async">{{field.label}}</mat-checkbox> -->
@if (showField$ | async) {
  <mat-checkbox [attr.name]="field.name" [formControl]="$any(field.control)" >{{field.label | translate}} @if (field.label2) {
    <span><br/>{{field.label2 | translate}}</span>
  }</mat-checkbox>
}
@if (field.help) {
  <p>{{ field.help }}</p>
}